<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">REPORTES</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active">PEDIDOS</span>
    </li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>INFORME DE PEDIDOS</strong>
      </span>
    </div>

    <!-- FILTROS -->
    <div class="col-12 p-fondo">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-2">
          <span><strong>SUCURSAL: </strong></span>
          <Dropdown
            v-model="sucursalSelected"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
          />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>CÓDIGO PEDIDO: </strong></span>
          <InputNumber
            v-model="codigoPedido"
            placeholder="Código Pedido"
            :inputClass="'text-right'"
            :min="0"
            :useGrouping="false"
            @keyup.enter="BuscarFiltro"
          />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>MESA: </strong></span>
          <Dropdown
            v-model="mesaSelected"
            :options="mesas"
            optionLabel="numero"
            optionValue="id"
          />
        </div>

        <div class="field col-12 md:col-4">
          <span><strong>BUSCAR CLIENTE:</strong></span>
          <div class="p-inputgroup">
            <AutoComplete
              field="nombre"
              v-model="clienteSelected"
              :suggestions="clientesListadoFiltrado"
              @complete="buscarCliente($event)"
              placeholder="Buscar cliente..."
            />
            <Button
              :disabled="!clienteSelected"
              icon="pi pi-search"
              class="p-button-warning"
              @click="buscarCliente($event)"
              v-tooltip.top="'Buscar'"
            />
          </div>
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>MESERO: </strong></span>
          <Dropdown
            v-model="meseroSelected"
            :options="meseros"
            optionLabel="name"
            optionValue="id"
          />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>ESTADO PEDIDO: </strong></span>
          <Dropdown
            v-model="estadoSelected"
            :options="estados"
            optionLabel="nombre"
            optionValue="id"
          />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>TIPO PEDIDO: </strong></span>
          <Dropdown
            v-model="tipoSelected"
            :options="tipos"
            optionLabel="nombre"
            optionValue="id"
          />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>FECHA INICIO: </strong></span>
          <InputText type="date" v-model="fecha_inicio" dateFormat="dd/mm/yy" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>FECHA FIN: </strong></span>
          <InputText type="date" v-model="fecha_fin" dateFormat="dd/mm/yy" />
        </div>

        <div class="field col-12 md:col-2">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="BUSCAR"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Buscar'"
            :loading="enviando"
            :disabled="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>
    </div>

    <!-- TOTALES GENERALES -->
    <div class="mt-4 card style_card" v-if="pedidos.length > 0">
      <div class="p-fluid formgrid grid">
        <table class="table table-bordered table-striped" style="width: 100%">
          <tr>
            <th class="text-center">
              TOTAL PEDIDOS:
              <span class="p-badge p-badge-blue p-mr-2" style="font-size: 1rem">
                {{ totalesGenerales.total_pedidos }}
              </span>
            </th>
            <th class="text-center">
              TOTAL MONTO:
              <span
                class="p-badge p-badge-success p-mr-2"
                style="font-size: 1rem"
              >
                {{
                  convertirNumeroGermanicFormat(totalesGenerales.total_monto)
                }}
                Bs.
              </span>
            </th>
            <th class="text-center">
              PROMEDIO:
              <span class="p-badge p-badge-info p-mr-2" style="font-size: 1rem">
                {{ convertirNumeroGermanicFormat(totalesGenerales.promedio) }}
                Bs.
              </span>
            </th>
          </tr>
        </table>
      </div>

      <div class="mt-2 text-center text-sm text-secondary">
        <i class="pi pi-info-circle mr-2"></i>
        Los totales son del filtro completo ({{ totalRegistros }} registros).
        Mostrando página {{ paginaActual }} de
        {{ Math.ceil(totalRegistros / porPagina) }}
      </div>
    </div>

    <!-- DATATABLE CON PAGINACIÓN -->
    <div class="mt-4">
      <DataTable
        ref="reporte_pedidos"
        key="id"
        :value="pedidos"
        :lazy="true"
        :paginator="true"
        :rows="porPagina"
        :totalRecords="totalRegistros"
        :loading="enviando"
        @page="onPageChange"
        :rowsPerPageOptions="[25, 50, 100, 200]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        responsiveLayout="scroll"
        class="p-datatable-sm"
        stripedRows
        showGridlines
        v-model:expandedRows="expandedRows"
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                text
                icon="pi pi-minus"
                label="Contraer Todo"
                @click="collapseAll"
                class="mr-2 p-button-info"
              />
            </span>

            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                text
                icon="pi pi-plus"
                label="Expandir Todo"
                @click="expandAll"
                class="mr-2 p-button-info"
              />
            </span>

            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                v-if="'R_Ventas DescargarPDF' in auth.user.permissions"
                label="PDF Imprimir"
                icon="pi pi-file-pdf"
                class="p-button-outlined p-button-danger mr-2"
                v-tooltip.top="'Imprimir Reporte PDF'"
                :loading="generandoPDF"
                :disabled="generandoPDF || pedidos.length === 0"
                @click="generarPDF"
              />
            </span>

            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <Button
                v-if="'R_Ventas DescargarEXCEL' in auth.user.permissions"
                label="EXCEL Exportar"
                icon="pi pi-file-excel"
                class="p-button-outlined p-button-success"
                v-tooltip.top="'Imprimir Reporte Excel'"
                :loading="exportando"
                :disabled="exportando || pedidos.length === 0"
                @click="exportPedidos"
              />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center p-4">
            <ProgressSpinner />
            <span class="ml-3">Cargando pedidos...</span>
          </div>
        </template>

        <template #empty>
          <div class="text-center p-4">
            <i
              class="pi pi-info-circle"
              style="font-size: 2rem; color: #64748b"
            ></i>
            <p class="mt-2 text-secondary">
              Debe aplicar filtros para ver resultados en la tabla
            </p>
          </div>
        </template>

        <Column expander style="width: 1rem"></Column>

        <Column class="text-right" field="id" header="CÓD"></Column>

        <Column field="numero_mesa" header="MESA" class="text-center"></Column>

        <Column field="mesero" header="MESERO"></Column>

        <Column field="fecha_pedido" header="FECHA PEDIDO"></Column>

        <Column field="nombre_cliente" header="CLIENTE"></Column>

        <Column field="tipo" header="TIPO" class="text-center">
          <template #body="{ data }">
            <span
              class="product-badge"
              :class="{
                'status-instock': data.tipo === 'mesa',
                'status-lowstock': data.tipo === 'llevar',
                'status-outofstock': data.tipo === 'delivery',
              }"
            >
              {{ textoTipo(data.tipo) }}
            </span>
          </template>
        </Column>

        <Column field="total" header="TOTAL" class="text-right">
          <template #body="{ data }">
            {{ convertirNumeroGermanicFormat(data.total) }}
          </template>
        </Column>

        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span
              class="product-badge status"
              :class="{
                'status-outofstock': data.estado === 0,
                'status-instock': data.estado === 5,
                'status-lowstock': [1, 2, 3, 4].includes(data.estado),
              }"
            >
              {{ textoEstado(data.estado) }}
            </span>
          </template>
        </Column>

        <Column
          field="observaciones"
          header="OBSERVACIONES"
          style="min-width: 200px"
        >
          <template #body="{ data }">
            <span
              v-if="data.observaciones"
              v-tooltip.top="
                data.observaciones.length > 40 ? data.observaciones : ''
              "
              class="text-sm"
            >
              {{
                data.observaciones.length > 40
                  ? data.observaciones.substring(0, 40) + "..."
                  : data.observaciones
              }}
            </span>
            <span v-else class="text-gray-400 text-sm">-</span>
          </template>
        </Column>

        <ColumnGroup type="footer">
          <Row>
            <Column footer="TOTALES PÁGINA:" class="text-right" :colspan="7" />
            <Column
              class="text-right"
              :footer="convertirNumeroGermanicFormat(total_pagina)"
            />
          </Row>
        </ColumnGroup>

        <template #expansion="slotProps">
          <div class="p-3">
            <h5>
              <span style="border-bottom: 1px solid #ccc">
                DETALLE DE PEDIDO:
                <strong
                  >{{ slotProps.data.id }} - Mesa
                  {{ slotProps.data.numero_mesa }}</strong
                >
              </span>
            </h5>

            <div v-if="!slotProps.data.items" class="text-center p-4">
              <ProgressSpinner style="width: 30px; height: 30px" />
              <p class="mt-2">Cargando items...</p>
            </div>

            <DataTable
              v-else
              :value="slotProps.data.items"
              class="p-datatable-sm"
              responsiveLayout="scroll"
              stripedRows
              showGridlines
            >
              <Column field="id" header="COD_ITEM" class="text-center"></Column>
              <Column
                field="descripcion_producto"
                header="PRODUCTO/DESCRIPCIÓN"
                style="width: 300px; font-weight: bold"
              ></Column>
              <Column header="CANTIDAD" class="text-right">
                <template #body="slotProps">
                  {{ slotProps.data.cantidad }}
                </template>
              </Column>
              <Column header="PRECIO" class="text-right">
                <template #body="slotProps">
                  {{
                    convertirNumeroGermanicFormat(
                      slotProps.data.precio_unitario,
                    )
                  }}
                </template>
              </Column>
              <Column header="SUBTOTAL" class="text-right">
                <template #body="slotProps">
                  {{
                    convertirNumeroGermanicFormat(
                      slotProps.data.cantidad * slotProps.data.precio_unitario,
                    )
                  }}
                </template>
              </Column>
              <Column header="ESTADO" class="text-center">
                <template #body="slotProps">
                  <span
                    class="product-badge status"
                    :class="{
                      'status-outofstock': slotProps.data.estado === 0,
                      'status-instock': slotProps.data.estado === 3,
                      'status-lowstock': [1, 2].includes(slotProps.data.estado),
                    }"
                  >
                    {{ textoEstadoItem(slotProps.data.estado) }}
                  </span>
                </template>
              </Column>
              <Column header="NOTA COCINA">
                <template #body="slotProps">
                  {{ slotProps.data.nota_cocina || "-" }}
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import RestauranteService from "@/service/RestauranteService";
import ClienteService from "@/service/ClienteService";
import { useAuth } from "@/stores";

export default {
  data() {
    return {
      fecha_inicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      fecha_fin: new Date().toISOString().substr(0, 10),
      enviando: false,
      pedidos: [],
      sucursalSelected: 0,
      sucursales: [{ id: 0, nombre: "TODAS" }],
      meseroSelected: 0,
      meseros: [{ id: 0, name: "TODOS" }],
      mesaSelected: 0,
      mesas: [{ id: 0, numero: "TODAS" }],
      generandoPDF: false,
      exportando: false,
      clienteSelected: null,
      clientesListadoFiltrado: [],
      estadoSelected: 10,
      estados: [
        { id: 10, nombre: "TODOS" },
        { id: 0, nombre: "CANCELADO" },
        { id: 1, nombre: "PENDIENTE" },
        { id: 2, nombre: "EN COCINA" },
        { id: 3, nombre: "LISTO" },
        { id: 4, nombre: "ENTREGADO" },
        { id: 5, nombre: "PAGADO" },
      ],
      tipoSelected: "todos",
      tipos: [
        { id: "todos", nombre: "TODOS" },
        { id: "mesa", nombre: "MESA" },
        { id: "llevar", nombre: "PARA LLEVAR" },
        { id: "delivery", nombre: "DELIVERY" },
      ],
      codigoPedido: null,
      expandedRows: [],

      // PAGINACIÓN
      paginaActual: 1,
      porPagina: 50,
      totalRegistros: 0,

      // TOTALES GENERALES
      totalesGenerales: {
        total_pedidos: 0,
        total_monto: 0,
        promedio: 0,
      },
    };
  },

  computed: {
    total_pagina() {
      return this.pedidos.reduce((sum, p) => sum + parseFloat(p.total || 0), 0);
    },
  },

  created() {
    this.restauranteService = new RestauranteService();
    this.clienteService = new ClienteService();
    this.auth = useAuth();
  },

  mounted() {
    this.datos_necesarios_reporte_pedidos();
  },

  methods: {
    onPageChange(event) {
      this.paginaActual = event.page + 1;
      this.porPagina = event.rows;
      this.cargarReportePedidos();
    },

    datos_necesarios_reporte_pedidos() {
      this.restauranteService
        .datos_necesarios_reporte()
        .then((data) => {
          this.sucursales = data.datos.sucursales || [];
          this.sucursales.unshift({ id: 0, nombre: "TODAS" });

          this.meseros = data.datos.meseros || [];
          this.meseros.unshift({ id: 0, name: "TODOS" });

          this.mesas = data.datos.mesas || [];
          this.mesas.unshift({ id: 0, numero: "TODAS" });
        })
        .catch((error) => {
          console.error("Error cargando datos necesarios:", error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudieron cargar los datos necesarios",
            life: 3000,
          });
        });
    },

    textoEstado(estado) {
      const estados = {
        0: "CANCELADO",
        1: "PENDIENTE",
        2: "EN COCINA",
        3: "LISTO",
        4: "ENTREGADO",
        5: "PAGADO",
      };
      return estados[estado] || "DESCONOCIDO";
    },

    textoEstadoItem(estado) {
      const estados = {
        0: "CANCELADO",
        1: "PENDIENTE",
        2: "EN PREPARACIÓN",
        3: "LISTO",
      };
      return estados[estado] || "DESCONOCIDO";
    },

    textoTipo(tipo) {
      const tipos = {
        mesa: "MESA",
        llevar: "PARA LLEVAR",
        delivery: "DELIVERY",
      };
      return tipos[tipo] || tipo?.toUpperCase();
    },

    buscarCliente() {
      if (!this.clienteSelected) return;

      const texto =
        typeof this.clienteSelected === "string"
          ? this.clienteSelected
          : this.clienteSelected.nombre;

      const datos = {
        texto: texto,
        sucursal_id: this.sucursalSelected == 0 ? 1 : this.sucursalSelected,
      };

      this.clienteService
        .buscar(datos)
        .then((response) => {
          if (
            response.status == 400 ||
            !response.clientes ||
            response.clientes.length == 0
          ) {
            this.$toast.add({
              severity: "error",
              summary: "ERROR",
              detail: "No se encontró el cliente",
              life: 3000,
            });
            this.clientesListadoFiltrado = [];
            return;
          }
          this.clientesListadoFiltrado = [...response.clientes];
        })
        .catch((error) => {
          console.error("Error buscando:", error);
          this.clientesListadoFiltrado = [];
        });
    },

    exportPedidos() {
      if (this.pedidos.length === 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "No hay datos para exportar",
          life: 3000,
        });
        return;
      }

      this.exportando = true;
      const datos = {
        sucursal_id: this.sucursalSelected,
        mesero_id: this.meseroSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
        estado: this.estadoSelected,
        codigoPedido: this.codigoPedido,
        mesa_id: this.mesaSelected,
        tipo: this.tipoSelected,
      };

      this.restauranteService
        .exportarPedidos(datos)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Exportación exitosa",
            detail: "Se ha exportado correctamente",
            life: 3000,
          });
        })
        .catch((error) => {
          console.error("Error exportando:", error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudo exportar el reporte",
            life: 3000,
          });
        })
        .finally(() => {
          this.exportando = false;
        });
    },

    generarPDF() {
      if (this.pedidos.length === 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "No hay datos para generar el reporte",
          life: 3000,
        });
        return;
      }

      this.generandoPDF = true;
      const datos = {
        sucursal: this.sucursalSelected,
        mesero_id: this.meseroSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
        estado: this.estadoSelected,
        codigoPedido: this.codigoPedido,
        mesa_id: this.mesaSelected,
        tipo: this.tipoSelected,
      };

      this.restauranteService
        .imprimirPDFPedidos(datos)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Exito",
            detail: "Se generó el PDF correctamente",
            life: 3000,
          });
        })
        .catch((error) => {
          console.error("Error generando PDF:", error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudo generar el PDF",
            life: 3000,
          });
        })
        .finally(() => {
          this.generandoPDF = false;
        });
    },

    BuscarFiltro() {
      this.clientesListadoFiltrado = [];
      this.pedidos = [];
      this.paginaActual = 1;
      this.cargarReportePedidos();
    },

    cargarReportePedidos() {
      this.enviando = true;

      const datos = {
        sucursal: this.sucursalSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        mesero_id: this.meseroSelected,
        cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
        estado: this.estadoSelected,
        codigoPedido: this.codigoPedido,
        mesa_id: this.mesaSelected,
        tipo: this.tipoSelected,
        page: this.paginaActual,
        per_page: this.porPagina,
      };

      this.restauranteService
        .filtrarPedidos(datos)
        .then((response) => {
          if (response.success) {
            this.pedidos = response.pedidos || [];
            this.totalRegistros = response.pagination?.total || 0;

            this.totalesGenerales = {
              total_pedidos: response.totales_generales?.total_pedidos || 0,
              total_monto: parseFloat(
                response.totales_generales?.total_monto || 0,
              ),
              promedio: parseFloat(response.totales_generales?.promedio || 0),
            };
          } else {
            this.pedidos = [];
            this.totalRegistros = 0;
          }
        })
        .catch((error) => {
          console.error("Error cargando reporte:", error);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudieron cargar los pedidos",
            life: 3000,
          });
          this.pedidos = [];
          this.totalRegistros = 0;
        })
        .finally(() => {
          this.enviando = false;
        });
    },

    convertirNumeroGermanicFormat(numero) {
      if (!numero && numero !== 0) return "0,00";
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },

    expandAll() {
      this.expandedRows = this.pedidos.filter((p) => p.id);
    },

    collapseAll() {
      this.expandedRows = [];
    },
  },

  watch: {
    expandedRows(newVal) {
      if (newVal && newVal.length > 0) {
        newVal.forEach((pedido) => {
          if (!pedido.items) {
            this.restauranteService
              .obtenerDetallesPedido(pedido.id)
              .then((response) => {
                if (response.success) {
                  pedido.items = response.items;
                  this.$forceUpdate();
                }
              })
              .catch((error) => {
                console.error("Error cargando items:", error);
              });
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}

.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 10px;
}

.style_card {
  border: 1px solid #000000;
  border-bottom: 3px solid #000000;
  padding: 3px;
}
</style>
